export default "__VITE_ASSET__18646456__"